import { Component, Input } from "@angular/core";

@Component({
  selector: 'restock-status',
  templateUrl: './restock-status.component.html'
})
export class RestockStatusComponent {
  @Input()
  status!: string;

}